import { render } from "./CustomTopbar.vue?vue&type=template&id=2b2a53cf&scoped=true"
import script from "./CustomTopbar.vue?vue&type=script&lang=js"
export * from "./CustomTopbar.vue?vue&type=script&lang=js"

import "./CustomTopbar.vue?vue&type=style&index=0&id=2b2a53cf&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2a53cf"]])

export default __exports__